<template>
    <div id="favorites_hint_area">
        <div>{{ favorites_hint_text }}</div>
    </div>
</template>
<script>
    export default {
        name: 'FavoritesHint',

        props:{
            favorites_hint_text: {
                type: String,
                default: ""
            },
        },

        data() {
            return {
            }
        },
    }
</script>
<style lang="scss" scoped>
    #favorites_hint_area {
        z-index: 1000;
        display: flex;
        align-items: center;
        justify-content: center;
        
        div {
            width: 100%;
            height: 100%;
            padding: 0 5px;
            font-size: 12px;
            text-align: center;
            line-height: 42px;
            color: white;
            background-color: #191f35;
            border-radius: 8px;
        }

        &::after {
            content: '';
            position: absolute;
            top: -3px; 
            bottom: -3px;
            left: -3px; 
            right: -3px;
            background-image: linear-gradient(to right, #2366f8 0%, #2cfde1 100%);
            z-index: -1;
            border-radius: 8px;
        }
    }
</style>
